module.exports = __webpack_public_path__ + "static/media/ic_completed.0ba728dd.svg";